import { Box } from '@mui/material'
import useStyles from '~/common/hooks/useStyles'
import { red } from '~/common/styles/colors'

function getStyles() {
  return {
    keyword: {
      fontFamily: 'monospace',
      color: red[9],
      whiteSpace: 'nowrap',
    },
  }
}

/**
 * Keyword used in formulas to represent a specific action or operation
 */
export function FormulaKeyword({ children }: { children: React.ReactNode }) {
  const styles = useStyles(getStyles)
  return (
    <Box component="span" sx={styles.keyword}>
      {children}
    </Box>
  )
}
